import { render, staticRenderFns } from "./listAsessment.vue?vue&type=template&id=566b55ef&"
import script from "./listAsessment.vue?vue&type=script&lang=js&"
export * from "./listAsessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports